import { I18n } from '@calendly/i18n'

import { ButtonBlock, Container, PrimaryText, SecondaryText } from './empty_state_styles'
import { NewWorkflowButton } from './new_workflow_button'

export const EmptyTeamNoAccess = () => (
  <Container>
    <PrimaryText>
      {I18n.t('publisher.workflows.empty_state.no_access_banner.line1')}
    </PrimaryText>
    <SecondaryText>
      {I18n.t('publisher.workflows.empty_state.no_access_banner.line2')}
    </SecondaryText>
  </Container>
)

export const EmptyTeamWithAccess = ({ owner }) => (
  <Container>
    <PrimaryText>
      {I18n.t('publisher.workflows.empty_state.with_access_banner.line1')}
    </PrimaryText>
    <SecondaryText>
      {I18n.t('publisher.workflows.empty_state.with_access_banner.line2')}
    </SecondaryText>
    <ButtonBlock>
      <NewWorkflowButton owner={owner} />
    </ButtonBlock>
  </Container>
)
